import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from '@src/routes/index.tsx'

import '@root/styles/globals.css'
import '../styles/main.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '@src/components/PullToRefresh/index.scss'

import '@src/utils/i18n.js'
import { installGtmErrorListeners } from '@src/utils/gtmListeners.js'

installGtmErrorListeners()

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found')
}

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
